<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div>
              <h1 class="page-title">รายละเอียดการชำระเงิน</h1>
              <p class="page-subtitle">{{ typeLabel }} · ตรวจสอบหลักฐานการโอนและปรับสถานะการชำระเงิน</p>
            </div>
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>กลับ
            </button>
          </div>
        </div>

        <!-- Alerts -->
        <ngb-alert *ngIf="successMessage" type="success" [dismissible]="true" (closed)="successMessage = null"
          class="mb-3">
          <i class="bi bi-check-circle me-2"></i>{{ successMessage }}
        </ngb-alert>

        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" (closed)="error = null" class="mb-3">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
        </ngb-alert>

        <!-- Loading -->
        <div *ngIf="isLoading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>กำลังโหลดรายละเอียดการชำระเงิน...</p>
        </div>

        <div *ngIf="!isLoading && record" class="detail-container">
          <!-- ชื่อรายการ -->
          <div class="card mb-4 title-card">
            <div class="card-header bg-gradient-green text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-journal-text me-2"></i>ชื่อรายการ
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="item-title-box">
                <div class="item-title-icon">
                  <i class="bi bi-book"></i>
                </div>
                <div>
                  <label class="item-title-label">{{ itemTitleLabel }}</label>
                  <div class="item-title-value">{{ record.itemTitle || '-' }}</div>
                </div>
              </div>

              <div class="row g-3 mt-1">
                <div class="col-md-4">
                  <div class="info-item">
                    <label class="info-label">ประเภทรายการ:</label>
                    <div class="info-value">{{ typeLabel }}</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info-item">
                    <label class="info-label">จำนวนเงิน:</label>
                    <div class="info-value fw-bold">{{ formatCurrency(record.amount) }} บาท</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="info-item">
                    <label class="info-label">วันและเวลาที่ทำรายการ:</label>
                    <div class="info-value">{{ formatDateTime(record.submittedAt) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ข้อมูลผู้ทำรายการ -->
          <div class="card mb-4">
            <div class="card-header bg-gradient-blue text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-person-circle me-2"></i>ข้อมูลผู้ทำรายการ
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ชื่อ-สกุลผู้สมัคร:</label>
                    <div class="info-value">{{ record.fullName || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เลขบัตรประชาชน:</label>
                    <div class="info-value font-monospace">{{ record.cid || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เบอร์โทร:</label>
                    <div class="info-value">{{ record.phoneNumber || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">หน่วยงาน/สังกัด:</label>
                    <div class="info-value">{{ record.organization || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">อีเมล:</label>
                    <div class="info-value">{{ record.email || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เลขที่สมาชิกสมาคม:</label>
                    <div class="info-value font-monospace">{{ record.memberNo || '-' }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">สถานะบัญชี:</label>
                    <div class="info-value">
                      <span class="badge" [ngClass]="record.accountActive ? 'bg-success' : 'bg-secondary'">
                        {{ record.accountActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ใบคำขอ:</label>
                    <div class="info-value">
                      <button type="button" class="btn btn-sm btn-outline-primary" (click)="viewRequestForm()">
                        <i class="bi bi-box-arrow-up-right me-1"></i>เปิดใบคำขอของผู้ทำรายการ
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- สถานะและการยืนยัน -->
          <div class="card mb-4 status-card">
            <div class="card-header bg-gradient-cyan text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-sliders me-2"></i>สถานะและการยืนยัน
              </h5>
              <p class="mb-0 mt-1 header-hint">
                <i class="bi bi-info-circle me-1"></i>คุณสามารถเปลี่ยนสถานะได้โดยเลือกจากรายการด้านล่าง
              </p>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">
                <div class="col-lg-6">
                  <div class="status-panel">
                    <label class="status-label">
                      <i class="bi bi-credit-card me-2"></i>สถานะการชำระเงิน:
                    </label>
                    <select class="form-select form-select-lg status-select" [(ngModel)]="selectedStatus"
                      (ngModelChange)="onStatusSelectionChanged()">
                      <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
                    </select>

                    <div class="status-badge-preview mt-2">
                      <span class="badge badge-lg" [ngClass]="getStatusBadgeClass(selectedStatus)">
                        <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                        {{ selectedStatus }}
                      </span>
                    </div>

                    <!-- เหตุผลการยกเลิก -->
                    <div class="mt-3" *ngIf="isCancelingPayment">
                      <label class="d-block text-muted mb-1" style="font-size: 0.85rem;">
                        <i class="bi bi-chat-left-text me-1"></i>เหตุผลการยกเลิก
                      </label>
                      <textarea class="form-control" rows="2" [(ngModel)]="cancelReason"
                        placeholder="ระบุเหตุผลการยกเลิกใบเสร็จ"></textarea>
                    </div>

                    <!-- หลักฐานการชำระเงิน -->
                    <div class="mt-3" *ngIf="record.paymentSlip">
                      <label class="d-block text-muted mb-2" style="font-size: 0.85rem;">
                        <i class="bi bi-receipt me-1"></i>หลักฐานการชำระเงิน
                      </label>

                      <div class="position-relative d-inline-block slip-thumb" (click)="openSlipPreview()">
                        <img *ngIf="!slipIsPdf" [src]="record.paymentSlip" alt="หลักฐานการชำระเงิน"
                          class="img-thumbnail">
                        <div *ngIf="slipIsPdf" class="pdf-thumb">
                          <i class="bi bi-file-earmark-pdf"></i>
                        </div>
                        <div class="position-absolute bottom-0 end-0 p-1 mb-1 me-1" style="pointer-events: none;">
                          <span class="badge bg-dark bg-opacity-75 rounded-pill">
                            <i class="bi bi-zoom-in me-1"></i>ดูรูป
                          </span>
                        </div>
                      </div>

                      <div class="mt-2 d-flex flex-wrap gap-2">
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="openSlipInNewTab()">
                          <i class="bi bi-box-arrow-up-right me-1"></i>เปิดรูปในแท็บใหม่
                        </button>
                        <button *ngIf="hasReceipt" type="button" class="btn btn-sm btn-outline-success"
                          (click)="viewReceipt()">
                          <i class="bi bi-receipt me-1"></i>ดูใบเสร็จ/ใบกำกับภาษี
                        </button>
                      </div>
                    </div>

                    <div class="alert alert-warning mt-3 mb-0 d-flex align-items-center" *ngIf="!record.paymentSlip">
                      <i class="bi bi-exclamation-triangle-fill me-2"></i>
                      <span>ผู้ทำรายการยังไม่ได้อัปโหลดหลักฐานการชำระเงิน</span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="status-panel">
                    <!-- วันเวลาการโอนเงิน -->
                    <label class="status-label">
                      <i class="bi bi-clock-history me-2"></i>วันเวลาการโอนเงิน:
                    </label>
                    <div class="transfer-datetime-box">
                      <div class="datetime-icon">
                        <i class="bi bi-calendar-check-fill"></i>
                      </div>
                      <div class="datetime-content">
                        <span class="datetime-text">{{ record.transferDateTime || 'ยังไม่ได้แจ้งวันเวลาโอน' }}</span>
                      </div>
                      <button type="button" class="btn btn-warning btn-edit-datetime" (click)="openReceiptDialog()"
                        [ngbTooltip]="'แก้ไขวันเวลาการโอนเงิน / ประเภทใบเสร็จ'">
                        <i class="bi bi-pencil-square me-1"></i>แก้ไข
                      </button>
                    </div>

                    <!-- ข้อมูลใบเสร็จ -->
                    <label class="status-label mt-4">
                      <i class="bi bi-receipt-cutoff me-2"></i>ใบเสร็จ:
                    </label>
                    <div class="receipt-box" [class.issued]="hasReceipt">
                      <div *ngIf="hasReceipt" class="d-flex flex-wrap align-items-center gap-2">
                        <span class="text-muted">เลขที่ใบเสร็จ:</span>
                        <span class="fw-bold font-monospace">{{ record.codeReceipt }}</span>
                        <span class="badge bg-light text-dark border">{{ getReceiptTypeLabel(record.receiptType) }}</span>
                        <button type="button" class="btn btn-sm btn-success ms-auto" (click)="viewReceipt()">
                          <i class="bi bi-printer me-1"></i>พิมพ์ใบเสร็จ
                        </button>
                      </div>
                      <div *ngIf="!hasReceipt" class="text-muted">
                        <i class="bi bi-info-circle me-1"></i>ยังไม่ได้ออกใบเสร็จ
                      </div>
                    </div>

                    <div class="alert alert-success mt-3 mb-0 d-flex align-items-center" *ngIf="willIssueReceipt">
                      <i class="bi bi-receipt-cutoff me-2 fs-5"></i>
                      <span>กด "บันทึกข้อมูล" แล้วระบบจะออกใบเสร็จและเลขที่ใบเสร็จให้ทันที</span>
                    </div>

                    <div class="alert alert-warning mt-3 mb-0 d-flex align-items-center"
                      *ngIf="isCancelingPayment && record.codeReceipt">
                      <i class="bi bi-exclamation-triangle me-2 fs-5"></i>
                      <span>ใบเสร็จเลขที่ {{ record.codeReceipt }} จะถูกทำเครื่องหมายว่ายกเลิก</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- คำแนะนำ -->
          <div class="alert alert-info d-flex align-items-start">
            <i class="bi bi-lightbulb me-2 mt-1"></i>
            <div>
              <strong>คำแนะนำ:</strong> ตรวจวันเวลาบนสลิปให้ตรงกับที่ผู้ใช้แจ้ง
              ถ้าไม่ตรงให้กด "แก้ไข" ที่วันเวลาการโอนเงินก่อน แล้วจึงปรับสถานะและกด "บันทึกข้อมูล"
            </div>
          </div>

          <!-- พร้อมบันทึกข้อมูล -->
          <div class="alert alert-success d-flex align-items-center">
            <i class="bi bi-check-circle-fill me-3" style="font-size: 2rem;"></i>
            <div>
              <strong>พร้อมบันทึกข้อมูล</strong>
              <p class="mb-0 mt-1">กรุณาตรวจสอบข้อมูลให้ถูกต้องและเลือกสถานะที่เหมาะสมก่อนกดปุ่ม "บันทึกข้อมูล"</p>
            </div>
          </div>

          <!-- Footer actions -->
          <div class="form-navigation mt-4">
            <div class="d-flex justify-content-between flex-wrap gap-2">
              <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
                <i class="bi bi-arrow-left me-2"></i>ย้อนกลับ
              </button>
              <div class="ms-auto d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="goBack()">ยกเลิก</button>
                <button type="button" class="btn btn-success" (click)="saveStatus()" [disabled]="isSaving">
                  <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                  <i *ngIf="!isSaving" class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- แก้ไขใบเสร็จ -->
<ng-template #receiptModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-pencil-square me-2"></i>แก้ไขใบเสร็จ
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body" *ngIf="record">
    <div class="alert alert-info d-flex align-items-start">
      <i class="bi bi-info-circle-fill me-2 mt-1"></i>
      <div class="small">
        แก้ไขวันเวลาที่โอนเงินให้ตรงกับสลิป ระบบจะแก้ไขใบเสร็จที่ออกไปแล้วให้ตรงกันด้วย
      </div>
    </div>

    <div class="mb-3" *ngIf="record.paymentSlip">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="openSlipPreview()">
        <i class="bi bi-receipt me-1"></i>ดูสลิปการโอน
      </button>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        <i class="bi bi-clock-history me-1"></i>วันที่และเวลาที่โอนเงิน
      </label>
      <input type="text" class="form-control form-control-lg" [(ngModel)]="receiptTransferDateTime"
        placeholder="เช่น 5 ตุลาคม 2569 เวลา 12:36 น.">
      <small class="text-muted">กรอกตามวันเวลาที่ปรากฏบนสลิปการโอน</small>
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">
        <i class="bi bi-file-earmark-text me-1"></i>ประเภทใบเสร็จ
      </label>
      <div class="d-flex gap-3 flex-wrap">
        <div class="form-check">
          <input class="form-check-input" type="radio" id="detail-receipt-individual" value="individual"
            [(ngModel)]="receiptTypeValue">
          <label class="form-check-label" for="detail-receipt-individual">
            <i class="bi bi-person me-1"></i>ออกใบเสร็จแบบบุคคลธรรมดา
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="radio" id="detail-receipt-company" value="company"
            [(ngModel)]="receiptTypeValue">
          <label class="form-check-label" for="detail-receipt-company">
            <i class="bi bi-building me-1"></i>ออกใบเสร็จแบบนิติบุคคล
          </label>
        </div>
      </div>
    </div>

    <div class="alert alert-secondary mb-0" *ngIf="record.codeReceipt">
      ใบเสร็จเลขที่ <span class="fw-bold font-monospace">{{ record.codeReceipt }}</span> จะถูกแก้ไขตามข้อมูลนี้
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">ยกเลิก</button>
    <button type="button" class="btn btn-success" (click)="saveReceiptInfo(modal)" [disabled]="isSavingReceipt">
      <span *ngIf="isSavingReceipt" class="spinner-border spinner-border-sm me-2"></span>
      <i *ngIf="!isSavingReceipt" class="bi bi-check-circle me-2"></i>บันทึกข้อมูล
    </button>
  </div>
</ng-template>

<!-- Payment Slip Preview (ย่อ-ขยายได้) -->
<div class="slip-preview-overlay" *ngIf="showSlipPreview" (click)="closeSlipPreview()"
  (mousemove)="onSlipDragMove($event)" (mouseup)="onSlipDragEnd()" (mouseleave)="onSlipDragEnd()">
  <div class="slip-preview-dialog" (click)="$event.stopPropagation()">
    <div class="slip-preview-toolbar">
      <span class="slip-preview-title">
        <i class="bi bi-receipt me-2"></i>หลักฐานการชำระเงิน
      </span>

      <div class="slip-preview-actions">
        <ng-container *ngIf="!slipPreviewIsPdf">
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipOut()" [ngbTooltip]="'ย่อ'">
            <i class="bi bi-zoom-out"></i>
          </button>
          <span class="slip-zoom-level">{{ slipZoomPercent }}%</span>
          <button type="button" class="btn btn-sm btn-light" (click)="zoomSlipIn()" [ngbTooltip]="'ขยาย'">
            <i class="bi bi-zoom-in"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light" (click)="resetSlipZoom()" [ngbTooltip]="'ขนาดเดิม'">
            <i class="bi bi-arrow-counterclockwise"></i>
          </button>
        </ng-container>

        <button type="button" class="btn btn-sm btn-light" (click)="openSlipInNewTab()" [ngbTooltip]="'เปิดในแท็บใหม่'">
          <i class="bi bi-box-arrow-up-right"></i>
        </button>
        <button type="button" class="btn btn-sm btn-light" (click)="closeSlipPreview()" [ngbTooltip]="'ปิด'">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>

    <div class="slip-preview-body" [class.is-zoomed]="slipZoom > 1"
      (wheel)="!slipPreviewIsPdf && onSlipWheel($event)" (mousedown)="onSlipDragStart($event)">
      <iframe *ngIf="slipPreviewIsPdf" [src]="slipPreviewUrl | safe:'resourceUrl'" class="slip-preview-pdf"
        title="หลักฐานการชำระเงิน">
      </iframe>

      <img *ngIf="!slipPreviewIsPdf" [src]="slipPreviewUrl" alt="หลักฐานการชำระเงิน" class="slip-preview-image"
        [style.transform]="'translate(' + slipOffsetX + 'px, ' + slipOffsetY + 'px) scale(' + slipZoom + ')'"
        draggable="false">
    </div>

    <div class="slip-preview-hint" *ngIf="!slipPreviewIsPdf">
      <i class="bi bi-info-circle me-2"></i>
      <span>เลื่อนลูกกลิ้งเมาส์เพื่อย่อ-ขยาย · ลากเพื่อเลื่อนภาพเมื่อขยายแล้ว · กด Esc หรือคลิกพื้นหลังเพื่อปิด</span>
    </div>
  </div>
</div>
